(() => {
  const selector = '[data-cart-offer-price]';
  const formatter = new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL'
  });

  function money(cents) {
    return formatter.format(Number(cents || 0) / 100);
  }

  function offerFrom(root, tier) {
    const enabled = root.dataset['cartOffer' + tier + 'Enabled'] === 'true';
    const goal = Number(root.dataset['cartOffer' + tier + 'Goal'] || 0);
    const price = Number(root.dataset['cartOffer' + tier + 'Price'] || 0);
    return enabled && goal > 0 && price >= 0 ? { goal, price } : null;
  }

  function replaceTokens(template, goal, price) {
    return String(template || '')
      .replace(/\[quantidade\]/g, String(goal))
      .replace(/\[preco\]/g, money(price));
  }

  function nextOffer(root, itemCount) {
    if (root.dataset.cartOfferDynamic !== 'true' || itemCount < 1) return null;

    const nextCount = itemCount + 1;
    const first = offerFrom(root, 'One');
    const second = offerFrom(root, 'Two');

    if (second && nextCount >= second.goal) return second;
    if (first && nextCount >= first.goal) return first;
    return null;
  }

  function renderNotes(root, selectedOffer) {
    const notes = root.querySelector('[data-cart-offer-notes]');
    if (!notes) return;
    notes.replaceChildren();

    if (selectedOffer) {
      const note = document.createElement('span');
      note.dataset.cartOfferActiveNote = '';
      note.textContent = replaceTokens(root.dataset.cartOfferActiveLabel, selectedOffer.goal, selectedOffer.price);
      notes.append(note);
      return;
    }

    const first = offerFrom(root, 'One');
    const second = offerFrom(root, 'Two');
    [
      first && { goal: first.goal, price: first.price, template: root.dataset.cartOfferLabelOne, key: 'One' },
      second && { goal: second.goal, price: second.price, template: root.dataset.cartOfferLabelTwo, key: 'Two' }
    ].filter(Boolean).forEach((offer) => {
      const note = document.createElement('span');
      note.dataset['cartOfferNote' + offer.key] = '';
      note.textContent = replaceTokens(offer.template, offer.goal, offer.price);
      notes.append(note);
    });
  }

  function updatePrice(root, itemCount) {
    const selectedOffer = nextOffer(root, itemCount);
    const active = Boolean(selectedOffer);
    const activePrice = root.querySelector('[data-cart-offer-active-price]');
    const currentPrice = root.querySelector('[data-cart-offer-current-price]');
    const originalPrice = root.querySelector('[data-cart-offer-original-price]');

    root.classList.toggle('cart-offer--active', active);
    const priceElement = root.closest('.price');
    if (priceElement) priceElement.classList.toggle('cart-offer--active', active);
    if (activePrice) activePrice.hidden = !active;
    if (currentPrice && selectedOffer) currentPrice.textContent = money(selectedOffer.price);
    if (originalPrice) originalPrice.hidden = !active || root.dataset.cartOfferShowOriginal !== 'true';

    root.dataset.cartOfferInitialCount = String(itemCount);
    renderNotes(root, selectedOffer);
  }

  function updateAll(itemCount, container = document) {
    container.querySelectorAll(selector).forEach((root) => updatePrice(root, itemCount));
  }

  async function syncCart() {
    const cartUrl = window.routes && window.routes.cart_url ? window.routes.cart_url : '/cart';
    try {
      const response = await fetch(cartUrl + '.js', {
        credentials: 'same-origin',
        headers: { Accept: 'application/json' },
        cache: 'no-store'
      });
      if (!response.ok) return;
      const cart = await response.json();
      updateAll(Number(cart.item_count) || 0);
    } catch (error) {
      return;
    }
  }

  document.querySelectorAll(selector).forEach((root) => {
    updatePrice(root, Number(root.dataset.cartOfferInitialCount) || 0);
  });

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, syncCart);
  }

  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll(selector).forEach((root) => {
      updatePrice(root, Number(root.dataset.cartOfferInitialCount) || 0);
    });
  });

  window.addEventListener('pageshow', (event) => {
    if (event.persisted) syncCart();
  });
})();